import { render, staticRenderFns } from "./jinkoushangForm.vue?vue&type=template&id=6b4cf3fe&scoped=true&"
import script from "./jinkoushangForm.vue?vue&type=script&lang=js&"
export * from "./jinkoushangForm.vue?vue&type=script&lang=js&"
import style0 from "./jinkoushangForm.vue?vue&type=style&index=0&id=6b4cf3fe&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4cf3fe",
  null
  
)

export default component.exports